import styled, { css } from 'styled-components';


const GenericText = css<any>`
  ${props => props.fontWeight && `font-weight: ${props.fontWeight};`}
  ${props => props.font && `font-family: ${props.font};`}
  color: ${props =>
    props.customColor
      ? props.customColor
      : props.theme.color[props.color] || props.theme.color.mainFont};
  user-select: ${props => (props.nonSelect ? 'none' : 'auto')};
  text-align: ${props => (props.textAlign ? props.textAlign : 'initial')};
  white-space: ${props => (props.nowrap ? 'nowrap' : 'normal')};
  line-height: ${props =>
    props.lineHeight ? `${props.lineHeight}px` : 'normal'};
  text-transform: ${p => (p.textTransform ? p.textTransform : 'none')};
  word-break: ${p => (p.wordBreak ? p.wordBreak : 'normal')};
  overflow: ${p => (p.overflow || 'none')};
  word-wrap: break-word;

  ${p =>
    p.withEllipsis &&
    `
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `}
`;

export const H1 = styled.h1<any>`
  ${GenericText}
  font-size: 60px;
  line-height: 75px;
`;

export const H2 = styled.h2<any>`
  ${GenericText}
  font-size: 52px;
  line-height: 78px;
`;

export const H3 = styled.h3<any>`
  ${GenericText}
  font-size: 36px;
  line-height: 54px;
`;

export const H4 = styled.h4<any>`
  ${GenericText}
  font-size: 30px;
  line-height: 45px;
`;

export const H5 = styled.h5<any>`
  ${GenericText}
  font-size: 22px;
  line-height: 33px;
`;

export const H6 = styled.h6<any>`
  ${GenericText}
  font-size: 18px;
  line-height: 27px;
`;
export const Text = styled.p<any>`
  ${GenericText}
  font-size: ${props => props.fontSize || 16}px;
  line-height: ${props => props.fontSize ? Math.ceil(props.fontSize * 1.5) : 24}px;
`;

export const TinyText = styled.p<any>`
  ${GenericText}
  font-size: 12px;
  line-height: 18px;
`;
